import { Component, ElementRef, EventEmitter, HostListener, Input, OnChanges, OnInit, Output, ViewChild } from '@angular/core';
import { DateUtil } from 'app/core/utils/DateUtil';

@Component({
  selector: 'bz-date-time-picker',
  templateUrl: './date-time-picker.component.html',
  styleUrls: ['./date-time-picker.component.scss']
})
export class DateTimeFilterComponent implements OnInit {
  @ViewChild('dpDate') dpDate: ElementRef;
  @ViewChild('dpDateInput') dpDateInput: ElementRef;

  @Input() currentDate: string;
  @Input() isDisabled: boolean = false;
  @Input() dateMax: Date = new Date();

  @Output() valueChange = new EventEmitter<Date>();
  @Output() onBtnFilterClick = new EventEmitter();

  currentDateToShow: Date = new Date();
  timePickers: any = { currentDate: false };
  pickers: any = { currentDate: false };

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    const target = event.target as HTMLElement;
    const selectors = ['.date-filter', '.time-picker-select', '.cdk-overlay-backdrop', '.cdk-overlay-transparent-backdrop'];
    if (!selectors.some(sel => target.closest(sel))) {
      this.pickers.currentDate = false;
      this.timePickers.currentDate = false;
    }
  }

  constructor() { }

  ngOnInit() {
    const contentElement = document.querySelector('.content');
    if (contentElement) {
      contentElement.addEventListener('click', function (e) {
        if (e.target.id === 'date-current') {
          return;
        }

        const datePicker = document.querySelector('bs-datepicker-container');
        if (datePicker != null && this.pickers.dpFrom) {
          $('#date-current').click();
          this.pickers.currentDate = false;
          this.timePickers.currentDate = false;
        }

      }.bind(this));
    }
  }

  ngOnChanges() {
    if (this.currentDate) {
      this.currentDateToShow = DateUtil.dateToShow(this.currentDate);
    }
  }

  ngOnDestroy() {
  }

  convertDateFormat(dateString: string): Date {
    const date = new Date(dateString);
    return date;
  }

  setDate(date: Date, zeroHour): void {
    if (zeroHour)
      date.setHours(0, 0, 0, 0);
    else
      date.setHours(23, 59, 59, 999);
  }

  public filter() {
    const dateFilter = { currentDate: this.currentDateToShow };
    this.onBtnFilterClick.emit(dateFilter);
  }

  public setDatePickerActive(picker, option) {    
    if (option === 0) {
      this.pickers[picker] = !this.pickers[picker];
      this.timePickers[picker] = false;
    } else {
      this.timePickers[picker] = !this.timePickers[picker];
      this.pickers[picker] = false;
    }
  }

  public executeFilter() {
    if (this.isValidDate(this.currentDateToShow) && this.isValidDate(this.dateMax)) {
      this.filter();
    }
  }

  public updateDate(date) {
    let dateToSet = date;
    if (date)
      this.currentDateToShow = dateToSet;
    

    this.valueChange.emit(this.currentDateToShow);
    this.filter();
  }

  // onDateMaxChange(newDate: Date) {
  //   this.dateMax = this.isDate(newDate);
  //   const inputElement = this.dpToInput.nativeElement;
  //   inputElement.value = this.getFormattedDate(newDate);
  //   this.executeFilter();
  // }

  onDateMinChange(newDate: Date) {
    let dateToSet = this.isDate(newDate);
    this.currentDateToShow = dateToSet;
    const inputElement = this.dpDateInput.nativeElement;
    inputElement.value = this.getFormattedDate(dateToSet);
    this.valueChange.emit(this.currentDateToShow);
    this.executeFilter();
  }

  isDate(dateInput: Date) {
    if (isNaN(dateInput.getTime()))
      return new Date();
    else
      return dateInput;
  }

  getFormattedDate(date) {
    const year = date.getFullYear();
    const month = ("0" + (date.getMonth() + 1)).slice(-2);
    const day = ("0" + date.getDate()).slice(-2);
    const hours = ('0' + date.getHours()).slice(-2);
    const minutes = ('0' + date.getMinutes()).slice(-2);
    const seconds = ('0' + date.getSeconds()).slice(-2);
    return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
  }

  isValidDate(d) {
    return d instanceof Date && !isNaN(d.getTime());
  }
}
